import { connect } from 'react-redux';

import { AppState } from '../../../../store/store';
import { TopicsActions } from '../../../../store/topics/topics.actions';

import { MenuTopics as Presentation } from './menu-topics.component';

export const MenuTopics = connect(
  (state: AppState) => ({
    selectedTopic: state.topics.selectedTopic,
  }),
  (dispatch) => ({
    selectTopic: (index: number) => { dispatch(TopicsActions.selectTopic(index)); },
    closeTopic: () => { dispatch(TopicsActions.closeTopic()); },
  }),
)(Presentation);
